import React, { useEffect, useState } from "react";
import { Table, Button } from "antd"; // Import Table and Button from Ant Design

function DairyDetails({ allData }) {
  console.log(allData)
  const [data, setData] = useState([]);
  // const [cattleLimit, setCattleLimit] = useState(3);

  useEffect(() => {
    setData(allData);
  }, [allData]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Actual Production",
      dataIndex: "actualProduction",
    },
    {
      title: "Annual Depreciation",
      dataIndex: "annualDeprication",
    },
    {
      title: "Daily Income",
      dataIndex: "dailyIncome",
    },
    {
      title: "Lactation Period",
      dataIndex: "lactationPeriod",
    },
    {
      title: "Life Of Animal",
      dataIndex: "lifeOfAnimal",
    },
    {
      title: "Milk Capacity",
      dataIndex: "milkingCapacity",
    },
    {
      title: "Milking Capacity During Visit",
      dataIndex: "milkingCapacityDuringVisit",
    },
    {
      title: "Monthly Depreciation",
      dataIndex: "monthlyDeprication",
    },
    {
      title: "Monthly Income",
      dataIndex: "monthlyIncome",
    },
    {
      title: "Purchase Price",
      dataIndex: "purchasePrice",
    },
    {
      title: "Selling Price",
      dataIndex: "sellingPrice",
    },
  ];

  // const handleViewAllCattles = () => {
  //   setCattleLimit(cattleLimit === 3 ? Infinity : 3);
  // };

  return (
    <div className="container-fluid mt-3">
      <div className="row">
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <div key={index} className="col-12 mb-4">
               <h5 className="shop-heading mb-2">{item?.shop?.name}</h5>
              <div className="card">
                <div className="card-header">
                </div>
                <div className="card-body">
                  {item?.cattles && item.cattles.length > 0 ? (
                    <div className="table-responsive">
                      <Table
                        dataSource={item.cattles}
                        columns={columns}
                        pagination={false}
                        rowKey={(record) => record.id}
                      />
                      {/* {item.cattles.length > 3 && (
                        <Button onClick={handleViewAllCattles} block>
                          {cattleLimit === 3 ? "View All" : "Show Less"}
                        </Button>
                      )} */}
                    </div>
                  ) : (
                    <div className="border rounded p-3 mb-3">
                      <p>No cattles data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 mb-4">
            <div className="card text-center">
              <div className="card-body">
                <p>No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DairyDetails;
